import { render, staticRenderFns } from "./compose-message.vue?vue&type=template&id=7b0356cf"
import script from "./compose-message.vue?vue&type=script&lang=js"
export * from "./compose-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports